import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoResourceType, DtoResourceType } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoResourceTypeEntityDataService } from '../interfaces/dto.resource.type.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceTypeEntityDataService extends EntityDataService<IDtoResourceType> implements IDtoResourceTypeEntityDataService {

    constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
        super(http, null, configService, loggingService);
    }

    public getForMandator$(mandator: string): Observable<IDtoResourceType[]> {
        return this.httpGet(`/api/web/resourcetype/mandator/${mandator}`)
            .pipe(map((entities: IDtoResourceType[]) => {
                const result: IDtoResourceType[] = [];
                if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
                    for (const entity of entities) {
                        result.push(this.createEntityFromJson(entity));
                    }
                }
                return result;
            }));
    }

    public async getForMandatorAsync(mandator: string): Promise<IDtoResourceType[]> {
        return (await this.getForMandator$(mandator).toPromise());
    }

    protected override createEntityFromJson(json: any): IDtoResourceType {
        const result: IDtoResourceType = (UtilsJson.deserialize(json, DtoResourceType) as IDtoResourceType);
        if (result !== null) {
            result.setReferences();
        }

        return result;
    }

}
